import EventBus from '~/EventBus'

export function isCloudflareChallenge(response) {
  return response?.headers?.['cf-mitigated'] === 'challenge'
}

async function waitForChallengeToPass() {
  return new Promise(resolve => {
    function handleMessage(event) {
      if (event.data.type === 'gate-passed') {
        window.removeEventListener('message', handleMessage)
        resolve(true)
      }
    }

    window.addEventListener('message', handleMessage)
  })
}

export async function handleCloudflareChallenge(config) {
  EventBus.$emit('show-cloudflare-challenge')

  const passed = await waitForChallengeToPass()

  if (!passed) throw config

  EventBus.$emit('close-cloudflare-challenge')

  return config
}
